/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { MODULE_LAYOUTS } from '@coursera-web/cds-labs';

import SearchCollectionsModule from 'bundles/search-common/components/experiments/merchInSearch/SearchCollectionsModule';

const styles = {
  container: css`
    margin: var(--cds-spacing-400) 0;
    border-radius: var(--cds-border-radius-200);
    overflow: hidden;
  `,
};
type Props = {
  numOfResults?: number;
};
const MerchandisingInSearchCollectionPlaceholder = (props: Props) => {
  const numOfResults = props.numOfResults;
  return (
    <div css={styles.container} data-testid="merchandising-in-search-collections-placeholder">
      <SearchCollectionsModule
        numOfEntriesPerCollection={numOfResults}
        isCollectionsLoading={true}
        layout={numOfResults === 2 ? MODULE_LAYOUTS.text4image8 : MODULE_LAYOUTS.text6image6}
        backgroundColor="grey"
        showAllEntries={true}
        showRoundedCorners
      />
    </div>
  );
};
export default MerchandisingInSearchCollectionPlaceholder;
